import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_treatment_ext_RowClass } from '../../../dbschema';

export class DgMktTreatmentExtensionContainerModel extends BaseContainerModel {
  bl_dgmkt_treatment_ext: bl_dgmkt_treatment_ext_RowClass =
    new bl_dgmkt_treatment_ext_RowClass();
}
